export const multiSelector = width => ({
  control: provided => ({
    ...provided,
    maxHeight: '100px',
    overflow: 'auto',
    width: width ? `${width}px` : 'auto'
  }),
  clearIndicator: provided => ({ ...provided, display: 'none' })
})
